<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs6>
        <div class="title">Assemblage Activiteit 30 Dagen</div>
        <GChart type="PieChart"
                :data="assemblyStatsData"
                :options="chartOptions" />
      </v-flex>
      <v-flex xs6>
        <div class="title">Toegangscontrole 7 Dagen</div>
        <GChart type="PieChart"
                :data="accessControlStatsData"
                :options="chartOptions" />
      </v-flex>
      <v-flex xs6>
        <div class="title">Klanten</div>
        <GChart type="PieChart"
                :data="clientData"
                :options="chartOptions" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { GChart } from 'vue-google-charts'
  export default {
    name: 'Home',
    components: {
      GChart
    },
    data() {
      return {
        assemblyStats: [],
        accessControlStats: [],
        assemblyStatsHeader: ['Assemblage Activiteit 30 Dagen', 'iMatches'],
        accessControlHeader: ['Toegangscontrole 7 Dagen', 'iMatches'],
        chartOptions: {
          legend: {
            position: 'right',
            alignment: 'center',
          },
        },
        assemblyClients: [],
        clientDataHeader: ['Client', 'iMatches'],    
      }
    },
    computed: {
      ...mapGetters([
        'oidcUser'
      ]),
      assemblyStatsData() {
        return [this.assemblyStatsHeader, ...this.assemblyStats]
      },
      accessControlStatsData() {
        return [this.accessControlHeader, ...this.accessControlStats]
      },
      clientData() {
        return [this.clientDataHeader, ...this.assemblyClients]
      },
    },
    methods: {
      getData() {
        this.$http.get('api/assembly/stats/30')
          .then(request => {
            var stats = request.data;
            var result = Object.keys(stats).map(function (key) {
              var name = stats[key].action;
              if (name == "Shipped") name = "Verscheept";
              if (name == "Created") name = "Aangemaakt";
              if (name == "Modified") name = "Veranderd";
              return [name, stats[key].count];
            });
            this.assemblyStats = result
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */,
        this.$http.get('api/analytics/accesscontrolstats/7')
          .then(request => {
            var stats = request.data;
            var result = Object.keys(stats).map(function (key) {
              var name = stats[key].type;
              return [name, stats[key].count];
            });
            this.accessControlStats = result
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */
        this.$http.get('api/assembly/clients/')
          .then(request => {
            var clients = request.data;
            var result = Object.keys(clients).map(function (key) {
              var name = clients[key].client + " (" + clients[key].count + ")";
              return [name, clients[key].count];
            });
            this.assemblyClients = result
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */          
      },
    },
    created() {
    },
    mounted() {
      this.getData()
    }
  }
</script>